
import {
  Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator';
import { OrderInfo } from '@/features/shipment/types';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { debounce } from 'ts-debounce';
import OrdersListingItem from './OrdersListingItem.vue';

@Component({
  components: {
    OrdersListingItem,
  },
})
export default class OrdersListingTable extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) orders!: OrderInfo[];

  @PropSync('loading', { required: false, default: false }) loadingSync!: boolean;

  get itemHeight(): number {
    return this.isMobile ? 120 : 60;
  }

  private fetchMoreOrdersListing(event) {
    this.debounceFetchOrders(event);
  }

  private debounceFetchOrders = debounce(this.fetchAndCommitOrdersListing, 200);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async fetchAndCommitOrdersListing(event: any): Promise<void> {
    const element = event.currentTarget || event.target;
    if (element && element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.$emit('fetchMore');
    }
  }
}
